// extracted by mini-css-extract-plugin
export default {"button":"P2KyRo","buttonContainer":"Sibg1R","loaderContainer":"vmmwBR"};